document.addEventListener('DOMContentLoaded', () => {
  const run = document.getElementsByClassName('area-card');

  if (run.length > 0) {
    const toggles = document.getElementsByClassName('collapse-toggle');

    Array.from(toggles).forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const parent = toggle.parentElement;
        const target = parent.nextElementSibling;

        if (toggle.dataset.toggleCollapse) {
          target.classList.add('hidden');
          parent.classList.add('rounded-b-md');
          toggle.classList.add('hidden');
          toggle.parentElement.querySelector('.collapse-open').classList.remove('hidden');
        }

        if (toggle.dataset.toggleExpand) {
          target.classList.remove('hidden');
          parent.classList.remove('rounded-b-md');
          toggle.classList.add('hidden');
          toggle.parentElement.querySelector('.collapse-close').classList.remove('hidden');
        }
      });
    });

    const toggleParents = document.getElementsByClassName('collapse-toggle-parent');

    Array.from(toggleParents).forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const trigger = toggle.querySelector('a:not(.hidden)');

        if(trigger) {
          trigger.click();
        }
      });
    });
  }
});
